(() => {
  'use strict';

  const OPEN_SELECTOR  = '[data-giabo-engraving-open]';
  const CLOSE_SELECTOR = '[data-giabo-engraving-close]';
  const APPLY_SELECTOR = '[data-giabo-engraving-apply]';

  // =========================
  // Scroll Lock (stabil, iOS-safe)
  // =========================
  let __giaboScrollY = 0;

  function lockScroll() {
    __giaboScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('giabo-engraving-lock');
    document.body.classList.add('giabo-engraving-lock');

    document.body.style.position = 'fixed';
    document.body.style.top = `-${__giaboScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.documentElement.classList.remove('giabo-engraving-lock');
    document.body.classList.remove('giabo-engraving-lock');

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo(0, __giaboScrollY);
  }

  function getModalFromButton(btn) {
    const id = btn && btn.getAttribute('aria-controls');
    if (!id) return null;
    return document.getElementById(id);
  }

  // =========================
  // Model-Key (robust)
  // =========================
  function getModelKeyFromHandle(handle) {
    const h = (handle || '').toLowerCase();
    if (h.includes('dreamer')) return 'dreamer';
    if (h.includes('kasai')) return 'kasai';
    if (h.includes('mokuzai')) return 'mokuzai';
    if (h.includes('mizu')) return 'mizu';
    if (h.includes('daichi')) return 'daichi';
    if (h.includes('kinzoku')) return 'kinzoku';
    if (h.includes('rainbow')) return 'rainbow';
    return 'default';
  }

  function posValueToSlug(posVal) {
    return posVal === 'bottom' ? 'unterteil' : 'oberteil';
  }

  function handValueToSlug(handVal) {
    const v = (handVal || '').toLowerCase();
    if (v === 'links' || v === 'left') return 'links';
    return 'rechts';
  }

  function fontValueToFamily(val) {
    switch ((val || '').toLowerCase()) {
      case 'poiret': return '"Poiret One", sans-serif';
      case 'gruppo': return '"Gruppo", sans-serif';
      case 'quicksand':
      default: return '"Quicksand", sans-serif';
    }
  }

  // =========================
  // Rainbow Farbe aus Handle
  // =========================
  function getRainbowColorFromHandle(handle) {
  let h = (handle || '').toLowerCase();

  // Sonderzeichen normalisieren
  h = h
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss');

  // ✅ WICHTIG: Grün-Fixes
  // Shopify-Handles sind "grun", Assets heißen aber "gruen"
  h = h.replace(/grün/g, 'gruen');
  h = h.replace(/grun/g, 'gruen');

  // Unterstützte Rainbow-Farben
  const colors = ['blau', 'rot', 'orange', 'lila', 'gelb', 'gruen'];

  for (let i = 0; i < colors.length; i++) {
    const c = colors[i];

    // trifft z. B.
    // giabo-kugelschreiber-rainbow-grun-gravur
    // giabo-kugelschreiber-rainbow-gruen-gravur
    if (
      h.includes(`-${c}-`) ||
      h.includes(`rainbow-${c}`) ||
      h.endsWith(`-${c}`)
    ) {
      return c;
    }
  }

  return null;
}

  function buildFilename(modelKey, posSlug, handSlug, productHandle, ext) {
    const e = ext || 'jpg';
    if (modelKey === 'rainbow') {
      const color = getRainbowColorFromHandle(productHandle);
      if (!color) return '';
      return `engraving-rainbow-${color}-${posSlug}-${handSlug}.${e}`;
    }
    return `engraving-${modelKey}-${posSlug}-${handSlug}.${e}`;
  }

  // =========================
  // Desktop Fallback-Positionen (nur falls CSS Vars fehlen)
  // =========================
  const TEXT_POS = {
    default: {
      oberteil:  { top: 50, left: 50, rotate: 0, size: 26, cylinder: 0.85, maxAngle: 34 },
      unterteil: { top: 62, left: 50, rotate: 0, size: 22, cylinder: 0.85, maxAngle: 34 }
    },
    dreamer: { oberteil: { top: 54, left: 50, rotate: 0, size: 36, cylinder: 0.85, maxAngle: 20 } },
    kasai:   { oberteil: { top: 50, left: 54, rotate: 0, size: 26, cylinder: 0.85, maxAngle: 34 } },
    mokuzai: { oberteil: { top: 50, left: 60, rotate: 0, size: 26, cylinder: 0.85, maxAngle: 34 } },
    mizu:    { oberteil: { top: 50, left: 54, rotate: 0, size: 26, cylinder: 0.85, maxAngle: 34 } },
    daichi:  {
      oberteil:  { top: 50, left: 54, rotate: 0, size: 26, cylinder: 0.85, maxAngle: 34 },
      unterteil: { top: 62, left: 52, rotate: 0, size: 22, cylinder: 0.85, maxAngle: 34 }
    },
    kinzoku: { oberteil: { top: 50, left: 54, rotate: 0, size: 26, cylinder: 0.85, maxAngle: 34 } },
    rainbow: {
      oberteil:  { top: 50, left: 54, rotate: 0, size: 35, cylinder: 0.85, maxAngle: 30 },
      unterteil: { top: 62, left: 52, rotate: 0, size: 22, cylinder: 0.85, maxAngle: 34 }
    }
  };

  // Mobile Fallback (nur size)
  const TEXT_POS_MOBILE = {
    default: { oberteil: { size: 18 }, unterteil: { size: 16 } },
    rainbow: { oberteil: { size: 20 }, unterteil: { size: 16 } },
    dreamer: { oberteil: { size: 22 } },
    mizu:    { oberteil: { size: 19 } },
    mokuzai: { oberteil: { size: 19 } }
  };

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  // Optional: Hand-Fallbacks (nur falls CSS Vars fehlen)
  const HAND_POS = {
    default: { right: {}, left: {} },
    mokuzai: { right: { left: 45, top: 53 }, left: { left: 54, top: 53 } },
    kasai:   { right: { left: 54, top: 50 }, left: { left: 50, top: 50 } },
    dreamer: { right: { left: 51, top: 53 }, left: { left: 49, top: 53 } },
    daichi: {
      oberteil:  { right: { left: 54, top: 50 }, left: { left: 50, top: 50 } },
      unterteil: { right: { left: 52, top: 62 }, left: { left: 48, top: 62 } }
    },
    rainbow: {
      oberteil:  { right: { left: 54, top: 50 }, left: { left: 50, top: 50 } },
      unterteil: { right: { left: 52, top: 62 }, left: { left: 48, top: 62 } }
    }
  };

  function getHandSlug(handSel) {
    const v = (handSel && handSel.value || '').toLowerCase();
    if (v.includes('links') || v === 'left') return 'left';
    return 'right';
  }

  function getHandPosOverride(modelKey, handSlug, posSlug) {
    const cfg = HAND_POS[modelKey] || HAND_POS.default;

    if (cfg && posSlug && cfg[posSlug] && cfg[posSlug][handSlug]) {
      return cfg[posSlug][handSlug] || {};
    }
    if (cfg && cfg[handSlug]) {
      return cfg[handSlug] || {};
    }
    return (HAND_POS.default[handSlug] || {});
  }

  function getMaxCharsForPos(posSlug) {
    return posSlug === 'unterteil' ? 20 : 15;
  }

  // Laser Optik
  const LASER_STYLE = {
    gold:   { color: '#C9A24B', shadow: '0 0 6px rgba(201,162,75,.55), 0 0 14px rgba(201,162,75,.22)' },
    silver: { color: '#D6D9DE', shadow: '0 0 6px rgba(214,217,222,.55), 0 0 14px rgba(214,217,222,.22)' },
    dark:   { color: '#111',    shadow: '0 0 6px rgba(0,0,0,.12)' }
  };

  function getLaserKey(modelKey) {
    if (modelKey === 'daichi' || modelKey === 'dreamer' || modelKey === 'kasai') return 'gold';
    if (modelKey === 'rainbow' || modelKey === 'mokuzai' || modelKey === 'kinzoku') return 'silver';
    return 'dark';
  }

  function applyLaserStyle(el, modelKey) {
    if (!el) return;
    const key = getLaserKey(modelKey);
    const cfg = LASER_STYLE[key] || LASER_STYLE.dark;
    el.style.color = cfg.color;
    el.style.textShadow = cfg.shadow;
  }

  // =========================
  // Preview Image
  // =========================
  function setImgWithFallback(img, urlA, urlB, onOk, onFail) {
    let triedB = false;

    img.onload = function() { if (onOk) onOk(); };
    img.onerror = function() {
      if (!triedB && urlB) {
        triedB = true;
        img.src = urlB;
        return;
      }
      if (onFail) onFail();
    };

    img.src = urlA;
  }

  function updatePreviewImage(modal) {
    if (!modal) return;

    const img = modal.querySelector('[data-giabo-engraving-preview-image]');
    const placeholder = modal.querySelector('[data-giabo-engraving-preview-placeholder]');
    const handleEl = modal.querySelector('[data-product-handle]');
    const posSel = modal.querySelector('[data-giabo-engraving-pos]');
    const handSel = modal.querySelector('[data-giabo-engraving-hand]');

    if (!img || !handleEl || !handSel) return;

    const productHandle = handleEl.getAttribute('data-product-handle') || '';
    const modelKey = getModelKeyFromHandle(productHandle);

    const posVal = posSel ? posSel.value : 'top';
    const handVal = handSel.value;

    const showPlaceholder = function() { if (placeholder) placeholder.style.display = 'flex'; };
    const hidePlaceholder = function() { if (placeholder) placeholder.style.display = 'none'; };

    let base = (window.GIABO_ASSET_BASE || '').toString();

    if (!base) {
      const anyDatasetUrl =
        img.dataset.imgTopRechts ||
        img.dataset.imgTopLinks ||
        img.dataset.imgBottomRechts ||
        img.dataset.imgBottomLinks ||
        '';
      const idx = anyDatasetUrl.indexOf('/assets/');
      if (idx !== -1) base = anyDatasetUrl.slice(0, idx + 8);
    }

    if (!base) {
      showPlaceholder();
      img.removeAttribute('src');
      return;
    }

    // Rainbow: Dateiname immer neu bauen
    if (modelKey === 'rainbow') {
      const posSlug = posValueToSlug(posVal);
      const handSlug = handValueToSlug(handVal);

      const fileJpg = buildFilename(modelKey, posSlug, handSlug, productHandle, 'jpg');
      const fileJPG = buildFilename(modelKey, posSlug, handSlug, productHandle, 'JPG');

      const urlA = fileJpg ? (base + fileJpg) : '';
      const urlB = fileJPG ? (base + fileJPG) : '';

      if (!urlA) {
        showPlaceholder();
        img.removeAttribute('src');
        return;
      }

      showPlaceholder();
      setImgWithFallback(img, urlA, urlB, hidePlaceholder, showPlaceholder);
      return;
    }

    // Andere: dataset first
    const wantTop = posVal !== 'bottom';
    const hv = (handVal || '').toLowerCase();
    const wantLeft = hv === 'left' || hv === 'links';

    const urlFromDataset =
      wantTop && !wantLeft ? img.dataset.imgTopRechts :
      wantTop &&  wantLeft ? img.dataset.imgTopLinks  :
      !wantTop && !wantLeft ? img.dataset.imgBottomRechts :
      img.dataset.imgBottomLinks;

    let finalUrl = urlFromDataset || '';

    if (!finalUrl) {
      const posSlug = posValueToSlug(posVal);
      const handSlug = handValueToSlug(handVal);

      const fileA = buildFilename(modelKey, posSlug, handSlug, productHandle, 'jpg');
      const fileB = buildFilename(modelKey, posSlug, handSlug, productHandle, 'JPG');

      const urlA = fileA ? (base + fileA) : '';
      const urlB = fileB ? (base + fileB) : '';

      if (!urlA) {
        showPlaceholder();
        img.removeAttribute('src');
        return;
      }

      showPlaceholder();
      setImgWithFallback(img, urlA, urlB, hidePlaceholder, showPlaceholder);
      return;
    }

    showPlaceholder();
    img.onload = function() { hidePlaceholder(); };
    img.onerror = function() { showPlaceholder(); };
    img.src = finalUrl;

    requestAnimationFrame(() => {
      if (img.complete && img.naturalWidth > 0) hidePlaceholder();
    });
  }

  // =========================
  // Cylinder Warp Text
  // =========================
  function renderCylinderText(wrapEl, rawText, posCfg, fontFamily, fontWeight, opts = {}) {
  if (!wrapEl) return;
  wrapEl.innerHTML = '';

  const text = (rawText || '').trim();
  if (!text) return;

  const cylinder = Number(posCfg.cylinder ?? 0.85);
  const maxAngle = Number(posCfg.maxAngle ?? 34);

  // ✅ NEW: Shading steuerbar (für Gelb runterdrehen)
  const shadeStrength = Number(opts.shadeStrength ?? 0.25); // vorher fix 0.25
  const minBrightness = Number(opts.minBrightness ?? 0.55); // vorher fix 0.55

  const line = document.createElement('div');
  line.style.display = 'inline-flex';
  line.style.alignItems = 'center';
  line.style.justifyContent = 'center';
  line.style.gap = '0px';
  line.style.whiteSpace = 'nowrap';
  line.style.transformStyle = 'preserve-3d';
  line.style.fontFamily = fontFamily;
  line.style.fontWeight = String(fontWeight);
  line.style.letterSpacing = '0.06em';
  wrapEl.appendChild(line);

  const chars = Array.from(text);
  chars.forEach((ch) => {
    const s = document.createElement('span');
    s.textContent = ch === ' ' ? '\u00A0' : ch;
    s.style.display = 'inline-block';
    s.style.transformStyle = 'preserve-3d';
    line.appendChild(s);
  });

  requestAnimationFrame(() => {
    const rect = line.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;

    const children = Array.from(line.children);
    children.forEach((node) => {
      const r = node.getBoundingClientRect();
      const cx = r.left + r.width / 2;

      const t = rect.width > 0 ? (cx - centerX) / (rect.width / 2) : 0;
      const clamped = Math.max(-1, Math.min(1, t));

      const angle = clamped * maxAngle * cylinder;

      const rad = Math.abs(angle) * Math.PI / 180;
      const squeeze = Math.max(minBrightness, Math.cos(rad));

      // ✅ NEW: brightness kontrollierbar
      const shade = 1 - (Math.abs(clamped) * shadeStrength * cylinder);

      node.style.transformOrigin = '50% 50%';
      node.style.transform = `rotateY(${angle}deg) scaleX(${squeeze})`;
      node.style.filter = `brightness(${shade})`;
    });
  });
}

  // =========================
  // Preview Text (CSS Vars haben Priorität)
  // =========================
  function readCssVar(el, name) {
    if (!el) return '';
    const v = getComputedStyle(el).getPropertyValue(name);
    return (v || '').trim();
  }

  function resolvePercent(cssVal, fallbackNum) {
    if (cssVal) {
      if (cssVal.endsWith('%')) return cssVal;
      const n = parseFloat(cssVal);
      if (!Number.isNaN(n)) return `${n}%`;
    }
    return `${fallbackNum}%`;
  }

  function resolveDeg(cssVal, fallbackNum) {
    if (cssVal) {
      if (cssVal.endsWith('deg')) return cssVal;
      const n = parseFloat(cssVal);
      if (!Number.isNaN(n)) return `${n}deg`;
    }
    return `${fallbackNum}deg`;
  }

  function updatePreviewText(modal) {
    if (!modal) return;

    const textEl  = modal.querySelector('[data-giabo-engraving-preview-text]');
    const inputEl = modal.querySelector('[data-giabo-engraving-input]');
    const fontSel = modal.querySelector('[data-giabo-engraving-font]');
    const posSel  = modal.querySelector('[data-giabo-engraving-pos]');
    const handSel = modal.querySelector('[data-giabo-engraving-hand]');

    if (!textEl || !inputEl) return;

    const productHandle = textEl.getAttribute('data-product-handle') || '';
    const modelKey = getModelKeyFromHandle(productHandle);

    const posSlug = posValueToSlug(posSel ? posSel.value : 'top');

    // maxlength
    const maxChars = getMaxCharsForPos(posSlug);
    inputEl.setAttribute('maxlength', String(maxChars));

    let rawText = inputEl.value || '';
    if (rawText.length > maxChars) {
      rawText = rawText.slice(0, maxChars);
      inputEl.value = rawText;
    }
    rawText = rawText.trim();

    // Font
    const currentFont = (fontSel && fontSel.value ? fontSel.value : 'poiret').toLowerCase();
    const fontFamily = fontValueToFamily(currentFont);

    let fontWeight = 400;
    if (currentFont === 'quicksand') fontWeight = 300;

    // Fallback posCfg
    const basePosCfg =
      (TEXT_POS[modelKey] && TEXT_POS[modelKey][posSlug]) ||
      (TEXT_POS.default && TEXT_POS.default[posSlug]) ||
      { top: 50, left: 50, rotate: 0, size: 26, cylinder: 0.85, maxAngle: 34 };

    let mobileCfg = {};
    if (isMobile()) {
      mobileCfg =
        (TEXT_POS_MOBILE[modelKey] && TEXT_POS_MOBILE[modelKey][posSlug]) ||
        (TEXT_POS_MOBILE.default && TEXT_POS_MOBILE.default[posSlug]) ||
        {};
    }

    const hSlug = getHandSlug(handSel);
    const handPos = getHandPosOverride(modelKey, hSlug, posSlug);

    const posCfg = Object.assign({}, basePosCfg, handPos, mobileCfg);
    // ✅ CSS VARS haben Priorität

// ✅ CSS VARS: pro Position (oberteil/unterteil) + optional Mobile + LINKS/RECHTS
const isM = isMobile();
const posKey = posSlug; // 'oberteil' oder 'unterteil'

function readVar(name) {
  return readCssVar(textEl, name);
}

// ✅ Händigkeit bestimmen (left/right)
const handVal = (handSel?.value || '').toLowerCase();
const isLeftHand = handVal.includes('left') || handVal.includes('links');
const sideKey = isLeftHand ? 'left' : 'right';

// ✅ pickVar: holt die passenden CSS-Variablen in dieser Reihenfolge:
// 1) Mobile + pos + side
// 2) Desktop + pos + side
// 3) Mobile + pos (neutral)
// 4) Desktop + pos (neutral)
// 5) alte Single-Var (neutral)
function pickVar(baseName) {
  const pos = posKey; // 'oberteil' oder 'unterteil'

  const sideSuffix = (sideKey === 'left') ? `-${pos}-left` : `-${pos}`;
  const neutralSuffix = `-${pos}`;

  return (
    // 1) Mobile + pos + side
    (isM ? readVar(`--giabo-${baseName}-m${sideSuffix}`) : '') ||

    // 2) Desktop + pos + side
    readVar(`--giabo-${baseName}${sideSuffix}`) ||

    // 3) Mobile + pos neutral
    (isM ? readVar(`--giabo-${baseName}-m${neutralSuffix}`) : '') ||

    // 4) Desktop + pos neutral
    readVar(`--giabo-${baseName}${neutralSuffix}`) ||

    // 5) alte Single-Var neutral
    readVar(`--giabo-${baseName}`)
  );
}

const cssTop  = pickVar('top');
const cssLeft = pickVar('left');
const cssRot  = pickVar('rotate');

// ✅ multiplier pro pos + side + optional mobile (gleiche Reihenfolge)
const multPosSide = (sideKey === 'left') ? `-${posKey}-left` : `-${posKey}`;

const cssMult =
  (isM ? readVar(`--giabo-font-multiplier-m${multPosSide}`) : '') ||
  readVar(`--giabo-font-multiplier${multPosSide}`) ||
  (isM ? readVar(`--giabo-font-multiplier-m-${posKey}`) : '') ||
  readVar(`--giabo-font-multiplier-${posKey}`) ||
  readVar(`--giabo-font-multiplier`);

const multNum = cssMult ? parseFloat(cssMult) : 1;
const fontMult = (!Number.isNaN(multNum) && multNum > 0) ? multNum : 1;

    textEl.style.position = 'absolute';
    textEl.style.left = resolvePercent(cssLeft, (posCfg.left != null ? posCfg.left : 50));
    textEl.style.top  = resolvePercent(cssTop,  (posCfg.top  != null ? posCfg.top  : 50));
    textEl.style.transform = `translate(-50%, -50%) rotate(${resolveDeg(cssRot, (posCfg.rotate != null ? posCfg.rotate : 0))})`;
    textEl.style.pointerEvents = 'none';

    // Laser-Look
    applyLaserStyle(textEl, modelKey);

    // ✅ Rainbow: pro Farbe Gravur-Kontrast feinsteuern
const rainbowColor = (modelKey === 'rainbow') ? getRainbowColorFromHandle(productHandle) : null;

// Default: nichts ändern (Laser-Style bleibt)
let cylOpts = {}; // Optionen für renderCylinderText

if (modelKey === 'rainbow' && rainbowColor === 'gelb') {
  textEl.style.color = '#9EA7B1'; 
  textEl.style.textShadow = '0 0 2px rgba(0,0,0,.28)';
  cylOpts = { shadeStrength: 0.04, minBrightness: 0.92 };
}

if (modelKey === 'rainbow' && (rainbowColor === 'lila' || rainbowColor === 'violett')) {
  // ✅ Lila: sichtbar machen → hell + stärkerer Kontrast/Outline via Shadow
  textEl.style.color = '#EEF1F4';
  textEl.style.textShadow =
    '0 0 6px rgba(0,0,0,.20), 0 1px 0 rgba(255,255,255,.18)';
  cylOpts = { shadeStrength: 0.18, minBrightness: 0.75 };
}

    // ✅ WICHTIG: wir akzeptieren BOTH (warp ODER wrap), damit es nie wieder bricht
const wrapEl = textEl.querySelector('[data-giabo-engraving-warp], [data-giabo-engraving-wrap]');
const finalSize = (posCfg.size || 26) * fontMult;

if (wrapEl) {
  // ✅ Zentrierung festnageln (damit der Text nach links + rechts wächst)
  wrapEl.style.width = '100%';
  wrapEl.style.height = '100%';
  wrapEl.style.display = 'flex';
  wrapEl.style.alignItems = 'center';
  wrapEl.style.justifyContent = 'center';
  wrapEl.style.textAlign = 'center';

  wrapEl.style.color = textEl.style.color;
  wrapEl.style.textShadow = textEl.style.textShadow;
  wrapEl.style.fontSize = `${finalSize}px`;

  // ✅ Render in den Warp/Wrap-Container
  renderCylinderText(wrapEl, rawText, posCfg, fontFamily, fontWeight, cylOpts);

} else {
  // Fallback (sollte praktisch nie passieren, aber trotzdem sauber)
  textEl.style.fontFamily = fontFamily;
  textEl.style.fontWeight = String(fontWeight);
  textEl.style.fontSize = `${finalSize}px`;
  textEl.style.textAlign = 'center';
  textEl.textContent = rawText;
}

    textEl.style.display = rawText ? 'block' : 'none';
  }

  function updateAll(modal) {
    updatePreviewImage(modal);
    updatePreviewText(modal);
  }

  // =========================
  // Properties übernehmen
  // =========================
  function applyToProperties(modal) {
    if (!modal) return;

    const inputEl = modal.querySelector('[data-giabo-engraving-input]');
    const fontSel = modal.querySelector('[data-giabo-engraving-font]');
    const posSel  = modal.querySelector('[data-giabo-engraving-pos]');
    const handSel = modal.querySelector('[data-giabo-engraving-hand]');

    const text = (inputEl && inputEl.value ? inputEl.value : '').trim();
    const font = (fontSel && fontSel.value) ? fontSel.value : 'poiret';
    const pos  = (posSel && posSel.value) ? posSel.value : 'top';
    const hand = (handSel && handSel.value) ? handSel.value : 'right';

    const propText = document.querySelector('[data-giabo-engraving-prop="text"]');
    const propFont = document.querySelector('[data-giabo-engraving-prop="font"]');
    const propPos  = document.querySelector('[data-giabo-engraving-prop="pos"]');
    const propHand = document.querySelector('[data-giabo-engraving-prop="hand"]');

    if (propText) propText.value = text;
    if (propFont) propFont.value = font;
    if (propPos)  propPos.value  = pos;
    if (propHand) propHand.value = hand;
  }

  // =========================
  // Open / Close
  // =========================
  function openModal(modal, opener) {
    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    lockScroll();

    updateAll(modal);

    const dialog = modal.querySelector('.giabo-engraving-modal__dialog');
    if (dialog && typeof dialog.focus === 'function') dialog.focus({ preventScroll: true });

    modal.__giaboOpener = opener || null;
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    unlockScroll();

    const opener = modal.__giaboOpener;
    if (opener && typeof opener.focus === 'function') opener.focus();
    modal.__giaboOpener = null;
  }

  // =========================
  // Events
  // =========================
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest(OPEN_SELECTOR);
    if (openBtn) {
      e.preventDefault();
      const modal = getModalFromButton(openBtn);
      openModal(modal, openBtn);
      return;
    }

    const closeEl = e.target.closest(CLOSE_SELECTOR);
    if (closeEl) {
      e.preventDefault();
      const modal = closeEl.closest('.giabo-engraving-modal');
      closeModal(modal);
      return;
    }

    const applyBtn = e.target.closest(APPLY_SELECTOR);
    if (applyBtn) {
      e.preventDefault();
      const modal = applyBtn.closest('.giabo-engraving-modal');
      applyToProperties(modal);
      closeModal(modal);
      return;
    }
  });

  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-giabo-engraving-pos], [data-giabo-engraving-hand], [data-giabo-engraving-font]')) return;
    const modal = e.target.closest('.giabo-engraving-modal');
    if (!modal || !modal.classList.contains('is-open')) return;
    updateAll(modal);
  });

  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-giabo-engraving-input]')) return;
    const modal = e.target.closest('.giabo-engraving-modal');
    if (!modal || !modal.classList.contains('is-open')) return;
    updatePreviewText(modal);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const modal = document.querySelector('.giabo-engraving-modal.is-open');
    if (modal) closeModal(modal);
  });

  // Bei Rotation/Resize: Text/Bild neu setzen
  window.addEventListener('resize', () => {
    const modal = document.querySelector('.giabo-engraving-modal.is-open');
    if (modal) updateAll(modal);
  });
})();

